import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import React from 'react';
import type { CommandStatus } from '../hooks/useCommandTracking';

interface Props {
  status: CommandStatus;
  agentName?: string;
}

const STATUS_CONFIG: Record<CommandStatus, { icon: string; text: MessageDescriptor; hint?: MessageDescriptor }> = {
  pending:   { icon: '⏳', text: msg`Executing…` },
  completed: { icon: '✅', text: msg`Completed` },
  failed:    { icon: '❌', text: msg`Failed` },
  timeout:   { icon: '⏰', text: msg`Timed out`, hint: msg`The agent may be offline` },
};

export default function CommandResultCard({ status, agentName }: Props) {
  const { i18n } = useLingui();
  const config = STATUS_CONFIG[status];
  return (
    <div className={`command-result-card command-result-${status}`}>
      <span className="command-result-icon">{config.icon}</span>
      <span className="command-result-text">{i18n._(config.text)}</span>
      {agentName && <span className="command-result-agent">{agentName}</span>}
      {config.hint && <span className="command-result-hint">{i18n._(config.hint)}</span>}
    </div>
  );
}
